import icon1 from '../images/icon/research.gif'
import icon2 from '../images/icon/durability.gif'
import icon3 from '../images/icon/digital-tra.gif'
import icon4 from '../images/icon/business-develop.gif'
import icon5 from '../images/icon/search.gif'
import icon6 from '../images/icon/warning.gif'



const Services = [
    {
        Id: '1',
        sImg: icon4,
        title: 'SDR de Vendas com IA',
        slug: 'agente-sdr-vendas-ia',
        thumb1: 'Strategy',
        thumb2: 'Consultation',
        description: 'Automatize sua prospecção com agentes inteligentes treinados para identificar, qualificar e engajar leads 24h por dia. Integramos com WhatsApp, e-mail e voz — com mensagens naturais e personalizadas para cada público.',
    },
    {
        Id: '2',
        sImg: icon2,
        title: 'Atendimento com IA',
        slug: 'Link-building',
        thumb1: 'Management',
        thumb2: 'Transfer',
        description: 'Reduza custos e eleve a experiência do cliente com agentes de IA empáticos e proativos. Atuamos em canais como WhatsApp, telefone, site e e-mail, garantindo respostas rápidas e personalizadas, 24 horas por dia.',
    },
    {
        Id: '3',
        sImg: icon3,
        title: 'Automação de Processos com IA',
        slug: 'International-SEO',
        thumb1: 'Landing Page',
        thumb2: 'Plugins',
        description: 'Elimine tarefas repetitivas e ganhe mais tempo para o que realmente importa. Criamos fluxos automatizados com inteligência artificial e ferramentas no-code, integrando com seus sistemas para máxima eficiência.',
    },
    {
        Id: '4',
        sImg: icon1,
        title: 'Análise Preditiva e Insights',
        slug: 'Enterprise-SEO',
        thumb1: 'Consultation',
        thumb2: 'solution',
        description: 'Transforme dados em decisões inteligentes. Utilizamos IA para prever demandas, antecipar comportamento de clientes e gerar insights estratégicos que apoiam o crescimento do seu negócio.',
    },
    {
        Id: '5',
        sImg: icon5,
        title: 'Geração de Conteúdo com IA',
        slug: 'SEO-audit',
        thumb1: 'Website',
        thumb2: 'Mobile App',
        description: 'Produza conteúdo profissional com escala e agilidade. Criamos artigos, posts e vídeos com apresentadores virtuais usando IA, mantendo qualidade, criatividade e alinhamento com sua marca.',
    },
    {
        Id: '6',
        sImg: icon6,
        title: 'Soluções Customizadas',
        slug: 'Penalty-recovery',
        description: 'Projetos sob medida para os desafios da sua empresa. Desenvolvemos soluções com modelos da OpenAI e APIs de IA, totalmente integradas aos seus processos internos — com resultados reais e mensuráveis.',
    },
]

export default Services;